'use strict';
import wootableDefaultSettings from './config/_wootableDefaultSettings';
import {ajax_handleNewContent, isInfiniteScroll} from './js_dzswtl/_ajax_loadNewPage';
import {DzswtlFilter} from './js_dzswtl/_filters';
import {DzswtlPagination} from './js_dzswtl/_pagination';
import {view_init, view_listResponsiveAutohide, view_reinit} from "./js_dzswtl/_dzswtl_view";
import {getSingletonAjaxContainer, loadScriptDZSWTLLightbox, wooTableInitialSetup} from "./js_dzswtl/_dzswtl_helpers";
import {extraButtonsInit} from "./js_dzswtl/_buttons";
import {init_add_cart_modal} from "./add-to-cart-modal/_add_to_cart_modal";
import {dzswtl_wishlistInit} from "./js_dzswtl/_wishlist";
import {svg_star} from './js_dzswtl/assets';
import {lazyloading_init} from "./js_common/_lazyloading";
import {convertPluginOptionsToFinalOptions, dzs_open_social_link} from "./js_common/_dzs_helpers";
import {
  DZSWTL_FILTERS_SINGLETON,
  DZSWTL_MODEL_SHOP_INITIALLY_SETUP,
  DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY,
  DZSWTL_TABLE_FILTERS_USER_SET_FILTERS
} from "./config/_dzswtl_constants";

window.dzswtl_block_changes = false; // -- block instant changes if there is a button that trigger changes
window.dzswtl_collect_args_in_timeout = false; // -- place a timeout so that filters can be collected
window.dzswtl_collect_args = {}; // -- args collected
window.dzswtl_product_ids_that_fit_query = []; // -- args collected
window.dzswtl_current_ids_on_page = []; // -- args collected

window.dzswtl_filter_referenceTaxonomyCount = null;


class DzsWooTable {

  cthis = null;
  $pagination = null;
  $innerRows = null;
  $targetShop = null;
  pagination_method = 'pages';
  hardCodedKeys = {};
  classPagination = null;
  view_layoutMode = 'list';
  view_responsiveIsPhone = false;
  filters = null;
  initOptions = {};
  actualSearch_forceUpdateFilters = {};

  constructor($cthis_, o) {

    this.cthis = jQuery($cthis_);
    this.initOptions = o;
    $cthis_.SelfInstance = this;

    this.classInit();
  }

  classInit() {

    var ww = 0, // -- window w
      widthContainer = 0
    ;

    var
      isBusyLoadingNewContent = false

    ;


    var pageOptions = {
      pages_curr: 1,
      pages_max: null,
    }


    var isEnableMultisharer = false
    ;
    var _w = jQuery(window);
    var inter_collect_args = 0;
    var inter_scrollToTopShop = 0;


    const selfClass = this;
    var $ = jQuery;
    var cthis = this.cthis;
    var o = selfClass.initOptions;

    init();


    function init() {


      wooTableInitialSetup(selfClass)

      selfClass.filters = new DzswtlFilter(selfClass);
      selfClass.classPagination = new DzswtlPagination(selfClass);

      cthis.get(0).SelfInstance = selfClass;


      pageOptions['pages_max'] = selfClass.cthis.attr('data-max_num_pages');


      selfClass.$innerRows = cthis.find('.dzs-woo-table--inner-rows');

      view_init();
      $(document).on('click.dzswtl', '.dzs-wtl-submit-changes-btn, .pagination-link, .button-functionality-purchase_lightbox', handle_mouse);


      $(window).on('resize', handle_resize);
      selfClass.handle_resize = handle_resize;
      selfClass.load_new_content = load_new_content;


      if (window.dzswtl_settings && window.dzswtl_settings.add_to_cart_modal === 'on') {
        init_add_cart_modal()
      }

      handle_resize();
      setTimeout(handle_resize, 100);


      extraButtonsInit();


      if (selfClass['pagination_method'] === 'scroll') {
        window.addEventListener('mousewheel', function (e) {
          var isScrollNotPossible = false;
          if (document.body.clientHeight < window.innerHeight) {
            isScrollNotPossible = true;
          }
          if (isScrollNotPossible) {
            handle_scroll(e);
          }
        });
      }
      $(window).on('scroll', handle_scroll);


      selfClass.cthis.css('opacity', '');
      setTimeout(function () {
        selfClass.cthis.addClass('inited');
      }, 100);


      if (String($('.dzs-woo-table--inner').eq(0).html()).indexOf('dzswtl-multisharer-but') > -1) {
        isEnableMultisharer = true;
      }


      if (isEnableMultisharer) {
        setTimeout(function () {
          if (window.dzswtl_settings && window.dzswtl_settings.site_url) {
            loadScriptDZSWTLLightbox();
          }
        }, 2000)
      }


      if (cthis.find('.dzsap-multisharer-but').length) {
        if (window.dzsap_init_multisharer) {

          window.dzsap_init_multisharer();
        }
      }


      lazyloading_init();

      reinit();
      reinit_stars();
      reinit_pagination();

      window[DZSWTL_MODEL_SHOP_INITIALLY_SETUP] = true;
    }

    function handle_resize(e) {
      ww = window.innerWidth;


      widthContainer = cthis.width();

      if (widthContainer < o.view_responsive_breakpointForPhone) {
        cthis.addClass('responsive-is-phone');
        selfClass.view_responsiveIsPhone = true;
      } else {
        cthis.removeClass('responsive-is-phone');
        selfClass.view_responsiveIsPhone = false;
      }


      if (selfClass.view_layoutMode === 'list') {
        view_listResponsiveAutohide(selfClass);
      }
    }


    function reinit(reinitPargs) {

      var reinitArgs = Object.assign({
        'getCurrentIdsOnPageCall': true
      }, reinitPargs)


      view_reinit(selfClass, reinitArgs);


      selfClass.filters.reinitFilters();


    }


    function reinit_pagination() {

    }

    function reinit_stars() {
      let _c = $('.star-rating-con');
      if (_c.length) {
        _c.each(function () {
          const _t = $(this);
          // -- we reinit
          var aux = _t.html();
          if (aux.indexOf('{{starssvg}}') > -1) {
            aux = aux.replace(/{{starssvg}}/g, svg_star + svg_star + svg_star + svg_star + svg_star);
            _t.html(aux);
          }
        })
      }
    }

    function handle_scroll(e) {

      var windowh = _w.scrollTop() + _w.height();

      if (selfClass['pagination_method'] === 'scroll') {
        if (pageOptions['pages_curr'] >= pageOptions['pages_max']) {
          return;
        }
        if (windowh >= cthis.offset().top + cthis.outerHeight() - 30) {
          if (!isBusyLoadingNewContent) {
            const newPaginationArgs = {
              'paged': pageOptions['pages_curr'] + 1,
              'call_from': 'scroll',
              'caller_event': 'PAGINATION_EVENT'
            };
            load_new_content(newPaginationArgs)
          }
        }
      }
      clearTimeout(inter_scrollToTopShop);
    }


    function handle_mouse(e) {

      var $t = $(this);

      if (e.type === 'click') {
        if ($t.hasClass('button-functionality-purchase_lightbox')) {
          setTimeout(function () {
            if (window.dzscsc_init) {
              dzscsc_init('.contentscroller.auto-init', {init_each: true})
            }
          }, 50);
        }
        if ($t.hasClass('pagination-link')) {
          // -- pagination click

          $t.parent().children().removeClass('current');
          $t.addClass('current');


          clearTimeout(inter_scrollToTopShop);
          inter_scrollToTopShop = setTimeout(function () {
            let aux = parseInt($(".dzs-woo-table").eq(0).offset().top, 10);
            $('html,body').animate({
              scrollTop: aux - 200
            }, 500);
          }, 1000);

        }


        if ($t.hasClass('dzs-wtl-submit-changes-btn')) {

          window.dzswtl_block_changes = false;


          var timeout = 10;
          $('.dzs-woo-table-filter-input').each(function () {
            var _t3 = $(this);


            setTimeout(function (arg) {
              arg.trigger('change');
            }, timeout, _t3);

            timeout += 10;


          })
        }
        if ($t.hasClass('builder-layer--btn-delete')) {
        }
      }
    }


    /**
     * init the ajax request
     * @param {Object} pargs
     * @returns {boolean}
     */
    function load_new_content(pargs) {


      var loadNewContentArgs = {
        'call_from': 'default',
        'paged': ''
      };


      if (pargs) {
        loadNewContentArgs = $.extend(loadNewContentArgs, pargs);
      }




      // -- leave a delay to accumulate
      if (window.dzswtl_collect_args_in_timeout && loadNewContentArgs.call_from !== 'now_do_it' && loadNewContentArgs.call_from !== 'sort-input') {
        clearTimeout(inter_collect_args);
        setTimeout(function () {
          const args = $.extend({}, window.dzswtl_collect_args);
          args.call_from = 'now_do_it';
          if (loadNewContentArgs.table_paged !== '') {
            args.table_paged = loadNewContentArgs.table_paged;
          }
          load_new_content(args);
        }, 300);

        return;
      }

      if (isBusyLoadingNewContent) {
        return;
      }


      const $dzsWooTableTarget = $('.dzs-woo-table.dzswtl-main-ajax-target');

      if ($dzsWooTableTarget.length) {
        selfClass['$targetShop'] = $dzsWooTableTarget.eq(0);
      } else {
        const $dzsWooTable = $('.dzs-woo-table');
        if ($dzsWooTable.length) {
          selfClass['$targetShop'] = $dzsWooTable.eq(0);
        }
      }

      // -- if we have no target shop
      if (selfClass['$targetShop'] === null) {
        return;
      }

      // -- if it's only one page, abort
      if (selfClass['$targetShop'].attr('data-max_num_pages') === '1' && loadNewContentArgs.call_from === 'scroll') {
        return;
      }


      const argsCurrentFilters = DzswtlFilter.constructAjaxCall(selfClass, loadNewContentArgs, pageOptions);


      var currArgsStringify = JSON.stringify(argsCurrentFilters);
      window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY] = currArgsStringify;


      window[DZSWTL_FILTERS_SINGLETON].handleAjaxContentLoading();


      cthis.addClass('ajax-loading-items');

      isBusyLoadingNewContent = true;


      cthis.find('.dzswtl--item-instance').removeClass('item-transitioning-in');
      if (!isInfiniteScroll(selfClass)) {
        cthis.find('.dzswtl--item-instance').addClass('item-transitioning-out');
      }
      var $ajaxContainer = getSingletonAjaxContainer();
      if (loadNewContentArgs.call_from === 'scroll' && isInfiniteScroll(selfClass)) {
        $ajaxContainer.find('.dzswtl--item-instance').addClass('item-transitioning-stay-in-place')
      }

      // -- load new content

      const payloadNewContent = {
        postdata: window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY],
        action: 'dzswtl_load_new_content'
      }
      if (window[DZSWTL_TABLE_FILTERS_USER_SET_FILTERS]) {
        payloadNewContent.userSetFilters = window[DZSWTL_TABLE_FILTERS_USER_SET_FILTERS];
      }


      const $feedPostContent = $('.dzswtl-feed--post-content');
      if ($feedPostContent) {
        payloadNewContent.caller_post_content = $feedPostContent.text();
      }
      payloadNewContent.caller_current_url = window.location.href;


      $.ajax({
        async: "true",
        method: "POST",
        url: window.dzswtl_settings.site_url + '/ajax-api/dzswtl_ajax/dzswtl_query_load_new_content/',
        data: payloadNewContent,
        dataType: 'html',
        success: function (response) {


          try {
            const arrLoadNewResponse = JSON.parse(response);
            const loadResponse = ajax_handleNewContent(selfClass, arrLoadNewResponse, pageOptions, loadNewContentArgs);

            if (loadResponse.actualSearch_forceUpdateFilters) {
              selfClass.actualSearch_forceUpdateFilters = loadResponse.actualSearch_forceUpdateFilters;
            }


            setTimeout(function () {
              reinit({
                'getCurrentIdsOnPageCall': false
              });
              reinit_pagination()
              if (window[DZSWTL_FILTERS_SINGLETON]) {
                window[DZSWTL_FILTERS_SINGLETON].reinit_getCurrentIdsOnPage();
              }
            }, 100);


          } catch (err) {
            console.error('cannot parse load_new_content - ', response);
            console.error(err);
          }
          setTimeout(function () {

            cthis.removeClass('ajax-loading-items');
          }, 5);
          isBusyLoadingNewContent = false;
          reinit_stars();
        },

        error: function (err) {
          console.error('error loading', err);
          cthis.removeClass('ajax-loading-items');
          isBusyLoadingNewContent = false;
          reinit_stars();
        }
      });


    }


  }

}

(function ($) {
  $.fn.dzswootable = function (argOptions) {


    var defaultOptions = Object.assign({}, wootableDefaultSettings());
    var o = convertPluginOptionsToFinalOptions(this, defaultOptions, argOptions);
    this.each(function () {
      var cthis = $(this);

      return new DzsWooTable(this, o);


    })

  }
})
(jQuery);


window.dzswtl_init = function ($) {
  jQuery('.dzs-woo-table').dzswootable();
  dzswtl_wishlistInit();
};


jQuery(document).ready(function ($) {

  window.dzswtl_init($);

})


window.trigger_change_on_target_inter = 0;
window.trigger_change_on_target = function (arg) {
  arg.trigger('change');
}


window.dzs_open_social_link = dzs_open_social_link;






